export enum EReportActions {
  TOGGLE_LOADING = 'saveReport/toggleLoading',
  TOGGLE_REPORT_STATE = 'report/toggleReportStatus',
  TOGGLE_ERROR = 'saveReport/toggleError',
  SET_SHARE_REPORT_URL = 'saveReport/setShareReportUrl',
}
